export const quoteRegions = [
  { id: "nsw", label: "New South Wales" },
  { id: "vic", label: "Victoria" },
  { id: "qld", label: "Queensland" },
  { id: "wa", label: "Western Australia" },
  { id: "sa", label: "South Australia" },
  { id: "tas", label: "Tasmania" },
  { id: "nt", label: "Northern Territory" },
  { id: "act", label: "Australian Capital Territory" },
];

export function regionLabelFromParam(value) {
  const match = quoteRegions.find(
    (region) => region.id === value || region.label === value
  );
  return match ? match.label : "";
}
